import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";

export async function fetchProviderContracts(providerId: string) {
  const { data, error } = await apiClient
    .from('provider_contracts')
    .select(`*, document:document_id(file_url)`)
    .eq('provider_id', providerId);

  if (error) {
    throw error;
  }

  // Flatten the linked document's url onto the contract as file_url.
  return (data ?? []).map(({ document, ...contract }) => ({
    ...contract,
    file_url: document?.file_url ?? null,
  }));
}

export default function useGetProviderContracts(providerId: string | undefined, enabled = true) {

  return useQuery({
    queryKey: keys.getProviderContracts(providerId!),
    queryFn: () => fetchProviderContracts(providerId!),
    enabled: enabled && !!providerId,
    staleTime: _3_DAYS
  })
}
